module.exports = __webpack_public_path__ + "static/media/icon-todo-tomorrow.4631eb34.svg";